import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25faeedd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=25faeedd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.3.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25faeedd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/erp_Product/erp_front/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('25faeedd', component.options)
    } else {
      api.reload('25faeedd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=25faeedd&scoped=true&", function () {
      api.rerender('25faeedd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuePictureViewer/index.vue"
export default component.exports